import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

import New from './New';
import Detail from './Detail';
import Overview from './Overview';

const ContractData = props => {
  const paths = {
    details: `${props.match.path}/:id`,
    new: `${props.match.path}/new`,
  };

  return (
    <Switch>
      <Route exact path={paths.new} render={routerProps => <New {...props} {...routerProps} />} />
      <Route exact path={paths.details} render={routerProps => <Detail {...props} {...routerProps} />} />
      <Route render={routerProps => <Overview {...props} {...routerProps} />} />
    </Switch>
  );
};

export default withRouter(ContractData);
